import Confirm from '@/components/dialogs/confirm'
import {create} from 'vue-modal-dialogs'

export default create(Confirm, 'content')
